module.exports = __webpack_public_path__ + "static/media/cf.d8dd15d3.svg";